import { render, staticRenderFns } from "./CustomBranding.vue?vue&type=template&id=6d12c293&scoped=true"
import script from "./CustomBranding.vue?vue&type=script&lang=ts"
export * from "./CustomBranding.vue?vue&type=script&lang=ts"
import style0 from "./CustomBranding.vue?vue&type=style&index=0&id=6d12c293&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d12c293",
  null
  
)

export default component.exports